import React, { Component } from "react";
import { parseString } from "xml2js";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import api from "../../api";
import Address from "../searchresults/Address";
import getPersonName from "../common/Name";

class EmailReportSection extends Component {
  state = {
    activeIndex: 0,
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    const { isSilverReport } = this.props;
    if (isSilverReport) this.loadSection(this.props.node, this.props);
    else this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      const { isSilverReport } = nextProps;
      if (isSilverReport) this.loadSection(nextProps.node, nextProps);
      else this.loadData(nextProps);
    }
  }

  loadSection = (node, props) => {
    const rows = [];
    const { isSilverReport } = props;
    let recLength = 0;
    if (isSilverReport) {
      const emailRecords = _.get(node, "emails[0].email");
      if (emailRecords && emailRecords.length > 0) {
        _.forEach(emailRecords, (emailRecord, index) => {
          rows.push(
            <Table.Row key={`rep_email_row_1_${index}`}>
              <Table.Cell width={2}>Email:</Table.Cell>
              <Table.Cell>{_.get(emailRecord, "_")}</Table.Cell>
            </Table.Row>
          );
        });
        recLength = rows.length;
      }
    } else {
      const emailRecords = _.get(
        node,
        "personReport.emails[0].searchResponse[0].responseData[0].emailRecord"
      );
      if (emailRecords !== undefined && emailRecords.length > 0) {
        _.forEach(emailRecords, (emailRecord, index) => {
          rows.push(
            <Table.Row
              key={`rep_email_row_1_${index}`}
              className="report-sub-section-header"
            >
              <Table.Cell>Name:</Table.Cell>
              <Table.Cell>
                {getPersonName(
                  _.get(emailRecord, "firstName[0]._", ""),
                  _.get(emailRecord, "middleName[0]._", ""),
                  _.get(emailRecord, "lastName[0]._", ""),
                  this.props
                )}
              </Table.Cell>
              <Table.Cell>Email:</Table.Cell>
              <Table.Cell>{`${_.get(emailRecord, "email[0]._")}@${_.get(
                emailRecord,
                "domain[0]._"
              )}`}</Table.Cell>
              <Table.Cell>Reported:</Table.Cell>
              <Table.Cell>{_.get(emailRecord, "reportDate[0]._")}</Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`rep_email_row_2_${index}`}>
              <Table.Cell>
                {" "}
                <span className="text-bold">Address:</span>
              </Table.Cell>
              <Table.Cell>
                <Address
                  addressNode={emailRecord.address[0]}
                  {...this.props}
                  fullAddress={_.get(
                    emailRecord.address[0],
                    "fullAddress[0]._"
                  )}
                  ignoreLine1="true"
                  noBreakIconsAndText
                />
              </Table.Cell>
              <Table.Cell>
                <span className="text-bold">IP:</span>
              </Table.Cell>
              <Table.Cell>{_.get(emailRecord, "IPAddress[0]._")}</Table.Cell>
              <Table.Cell>{ }</Table.Cell>
              <Table.Cell>{ }</Table.Cell>
            </Table.Row>
          );
        });
      }
      recLength = rows.length > 0 ? rows.length / 2 : 0;
    }
    if (recLength === 0) {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={100}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    props.updateItemCountBySection(props.sectionName, recLength);

    this.setState({
      rows,
      activeIndex: 0,
    });
  };

  loadData = (props) => {
    const sectionNode = _.get(props.reportData, "personReport.emails[0]");
    if (sectionNode) {
      this.loadSection(props.reportData, props);
    } else if (!localStorage.emailLoad) {
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "emails";
      localStorage.emailLoad = true;
      api.report
        .person(additionalData)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            this.loadSection(rslt, props);
            localStorage.removeItem("emailLoad");
          });
        })
        .catch((err) => console.log("email res error - ", err));
    }
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled className="jumpnext-on-smallscreen">
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Rep_Email_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Email Addresses Associated with Subject
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Rep_Email_Body`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{this.state.rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default EmailReportSection;



// WEBPACK FOOTER //
// ./src/components/reports/EmailReportSection.js